export default "__VITE_ASSET__Dog9Zuy8__"